import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button, Fade } from '@mui/material';
import UpdateIcon from '@mui/icons-material/Update';
import CloseIcon from '@mui/icons-material/Close';
import Title from '../../components/Title';
import MessageBox from '../../components/MessageBox';

const styles = {
    fade: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: 600,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    },
    buttonSubmit: {
        backgroundColor: '#1551B3',
        color: '#fff',
        borderRadius: '20px',
        height: '45px',
        textTransform: 'capitalize',
        fontWeight: 'bold',
        fontSize: 15,
        marginTop: '17px',
        minWidth: '220px'
    },
    buttonCancel: {
        backgroundColor: '#F5F5F5',
        color: '#174FB3',
        borderRadius: 20,
        height: '45px',
        textTransform: 'capitalize',
        fontWeight: 'bold',
        fontSize: 15,
        marginTop: '17px',
        minWidth: '220px'
    }
};

const ModalDescriptionStatus = ({ open, setOpen, onClose }) => {
    const [description, setDescription] = useState('');

    const handleClose = () => {
        setDescription('');
        setOpen(false);
    }

    const handleSave = () => {
        onClose(description);
        handleClose();
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
        >
            <Fade in={open}>
                <Box sx={styles.fade}>
                    <Title>
                        Alteração no Status
                    </Title>
                    <MessageBox>
                        Percebemos que houve uma alteração no Status da ocorrência. Por favor, informe a descrição.
                    </MessageBox>
                    <TextField
                        id="description"
                        label="Descrição"
                        multiline
                        rows={4}
                        variant="outlined"
                        fullWidth
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        margin="normal"
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'space-evenly', mt: 2 }}>
                        <Button
                            variant="outlined"
                            startIcon={<CloseIcon style={{ 'color': '#174FB3' }} />}
                            type='button'
                            style={styles.buttonCancel}
                            onClick={handleClose}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="outlined"
                            startIcon={<UpdateIcon style={{ 'color': '#fff' }} />}
                            onClick={handleSave}
                            style={styles.buttonSubmit}
                        >
                            Atualizar Ocorrência
                        </Button>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
};

export default ModalDescriptionStatus;
